export default "__VITE_ASSET__CdgXCW9b__"